"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPFxAddWebpartArguments = exports.SPFxAddWebpartOptions = void 0;
exports.SPFxAddWebpartOptions = [
    {
        name: "spfx-folder",
        type: "string",
        description: "Directory or Path that contains the existing SharePoint Framework solution.",
        required: true,
    },
    {
        name: "spfx-webpart-name",
        type: "string",
        shortName: "w",
        description: "Name for SharePoint Framework Web Part.",
        required: true,
        default: "helloworld",
    },
    {
        name: "spfx-framework-type",
        type: "string",
        shortName: "k",
        description: "Framework.",
        required: true,
        default: "react",
        choices: ["react", "minimal", "none"],
    },
    {
        name: "manifest-file",
        questionName: "manifest-path",
        type: "string",
        shortName: "t",
        description: "Specifies the app manifest file path.",
        required: true,
        default: "./appPackage/manifest.json",
    },
    {
        name: "local-teams-manifest-file",
        questionName: "local-manifest-path",
        type: "string",
        shortName: "l",
        description: "Specifies the app manifest template file path for local environment, it can be either absolute path or relative path to project root folder.",
        required: true,
        default: "./appPackage/manifest.local.json",
    },
];
exports.SPFxAddWebpartArguments = [];
//# sourceMappingURL=SPFxAddWebpartOptions.js.map